    var ErrorScreenController = function ($scope, $element, $attrs, errorScreenService) {

        $scope.options = $scope.options || {};

        $scope.showErrorScreen = false;

        $scope.appSettings = window.appSettings;

        var listenerId = errorScreenService.subscribe(function (show, errorId, options) {
            if (options && (!!$scope.options.global == !options.global))  return;
            $scope.options = _.assign($scope.options, options);
            if ($scope.options && $scope.options.errorType === errorId) {
                $scope.showErrorScreen = show;
            }
        });

        $scope.$on('$destroy', function () {
            errorScreenService.unsubscribe(listenerId);
        });
    };

    ErrorScreenController.$inject = ['$scope', '$element', '$attrs', 'errorScreenService'];


    module.exports = function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'template/directives/error-screen',
            scope: {
                options: '='
            },
            controller: ErrorScreenController
        };
    };
